	// Google Maps

	; (function (jQuery) {
	"use strict";

	function Google_Maps() {

		var global = {
			map: {},
			infoWindowsSet: []
		};

		var fn = {
			init: function ()
			{
				jQuery('.acf-map:visible').each(function()
				{
					fn.render_map(jQuery(this));
				});

				jQuery('.branch-locator__dropdown select').on('change', fn.branchLocationChange);
			},

			branchLocationChange: function(e)
			{
				let selector = jQuery(this);
				// Reset Other selectors
				selector.addClass('active');
				jQuery('.branch-locator__dropdown select:not(.active)').val(0);
				jQuery('.branch-details').hide(); // Hide all addresses
				let branchID = selector.val();
				if (branchID > 0)
				{
					let branchDetails = jQuery('#branch-id-' + branchID);
					branchDetails.show();
					// If Marker then direct to marker
					if (branchDetails.data('latt'))
					{
						let branchLatt = branchDetails.data('latt');
						let branchLong = branchDetails.data('long');
						global.map.panTo
						(
							new google.maps.LatLng(branchLatt, branchLong)
						);
						setTimeout(() => {
							global.map.setZoom(15);
						}, "400");
					}
					else
					{
						// center map
						fn.center_map(global.map);
					}
					// Show Details
				}
				else
				{
					// center map
					fn.center_map(global.map);
				}
				selector.removeClass('active');
			},


			// Render Visible Maps

			/*
			*  render_map
			*
			*  This function will render a Google Map onto the selected jQuery element
			*
			*  @type	function
			*  @date	8/11/2013
			*  @since	4.3.0
			*
			*  @param	$el (jQuery element)
			*  @return	n/a

			http://www.aliciaramirez.com/2015/02/advanced-custom-fields-google-maps-tutorial/

			*/

			render_map: function($el)
			{

				// var
				var $markers = $el.find('.marker');

				// vars
				var args = {
					zoom		: 10,
					center		: new google.maps.LatLng(0, 0),
					mapTypeControl : false,
					mapTypeId	: google.maps.MapTypeId.ROADMAP
				};

				// create map
				global.map = new google.maps.Map($el[0], args);

				// add a markers reference
				global.map.markers = [];

				// add markers
				$markers.each(function()
				{
					fn.add_marker(jQuery(this), global.map);
				});

				// center map
				fn.center_map(global.map);

			},


			/* Google Maps for Branches

			*  add_marker
			*
			*  This function will add a marker to the selected Google Map
			*
			*  @type	function
			*  @date	8/11/2013
			*  @since	4.3.0
			*
			*  @param	$marker (jQuery element)
			*  @param	map (Google Map object)
			*  @return	n/a
			*/

			add_marker: function($marker, map)
			{

				// var
				var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

				// create marker
				var marker = new google.maps.Marker({
					position : latlng,
					map : map
				});

				// add to array
				map.markers.push( marker );

				// if marker contains HTML, add it to an infoWindow
				if($marker.html() && $marker.attr('data-modal') !== "hide")
				{
					// create info window
					var infowindow = new google.maps.InfoWindow({
						content : $marker.html(),
						maxWidth : 320
					});

					global.infoWindowsSet.push(infowindow); // Push window to array to help removal when new window clicked

					// show info window when marker is clicked
					google.maps.event.addListener(marker, 'click', function()
					{
						fn.closeAllInfoWindows();
						infowindow.open(map, marker);
					});
				}

			},


			/*
			*  center_map
			*
			*  This function will center the map, showing all markers attached to this map
			*
			*  @type	function
			*  @date	8/11/2013
			*  @since	4.3.0
			*
			*  @param	map (Google Map object)
			*  @return	n/a
			*/

			center_map: function(map)
			{

				// vars
				var bounds = new google.maps.LatLngBounds();

				// loop through all markers and create bounds
				jQuery.each(map.markers, function(i, marker)
				{
					var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng());
					bounds.extend( latlng );
				});

				// only 1 marker?
				if( map.markers.length == 1 ) {
					// set center of map
					map.setCenter(bounds.getCenter());
					map.setZoom(15);
				} else {
					// fit to bounds
					//map.fitBounds( bounds );
					map.setCenter(new google.maps.LatLng( 25, 50 ));
					map.setZoom(2);
				}

			},


			// Used to Hide all open Google Map Info Windows
			closeAllInfoWindows: function()
			{
				for (var i=0;i<global.infoWindowsSet.length;i++) {
					global.infoWindowsSet[i].close();
				}
			}

		}
		jQuery(fn.init);
	}

	new Google_Maps();

})(jQuery);